module.exports = __webpack_public_path__ + "static/2front-about-company-mission-3-0e9896ec170e26a01e70980bb0375792.png";